import { render, staticRenderFns } from "./IcoCompass.vue?vue&type=template&id=1c7474e6"
import script from "./IcoCompass.vue?vue&type=script&lang=js"
export * from "./IcoCompass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports